import { render, staticRenderFns } from "./UserXcoinOrders.vue?vue&type=template&id=1d5361a7&scoped=true"
import script from "./UserXcoinOrders.vue?vue&type=script&lang=ts"
export * from "./UserXcoinOrders.vue?vue&type=script&lang=ts"
import style0 from "./UserXcoinOrders.vue?vue&type=style&index=0&id=1d5361a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5361a7",
  null
  
)

export default component.exports